
import React, { useEffect, useState } from "react";
import Footer from "../Footer";
import "../../css/BangGiaQuay.css";
import Img from "../../assets/Service/BangGiaQuayBanner.jpg";
const DATA_URL =
    "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/BangGia/BangGiaQuay.json";

const formatPrice = (price) => {
    if (price === null || price === undefined || price === "") {
        return "Liên hệ";
    }

    const number = Number(price);

    return Number.isFinite(number)
        ? new Intl.NumberFormat("vi-VN").format(number) + "đ"
        : price;
};

function timeToSeconds(value) {
    if (!value) return 0;
    if (typeof value === "number") return value;

    const text = String(value).trim();

    if (/^\d+$/.test(text)) return Number(text);

    if (text.includes(":")) {
        return text
            .split(":")
            .map(Number)
            .reduce((total, part) => total * 60 + part, 0);
    }

    const hours = Number(text.match(/(\d+)h/i)?.[1] || 0);
    const minutes = Number(text.match(/(\d+)m/i)?.[1] || 0);
    const seconds = Number(text.match(/(\d+)s/i)?.[1] || 0);

    return hours * 3600 + minutes * 60 + seconds;
}

function getYouTubeEmbedUrl(url) {
    if (!url) return "";

    try {
        const parsed = new URL(url);
        const host = parsed.hostname.replace(/^www\./, "");
        let id = "";

        if (host === "youtu.be") {
            id = parsed.pathname.split("/").filter(Boolean)[0] || "";
        } else if (
            ["youtube.com", "m.youtube.com", "youtube-nocookie.com"].includes(host)
        ) {
            if (parsed.pathname === "/watch") {
                id = parsed.searchParams.get("v") || "";
            } else {
                id =
                    parsed.pathname.match(
                        /^\/(?:embed|shorts|live)\/([^/?]+)/
                    )?.[1] || "";
            }
        }

        if (!id) return "";

        const start = timeToSeconds(
            parsed.searchParams.get("start") ||
            parsed.searchParams.get("t") ||
            0
        );

        return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}${start ? `?start=${start}` : ""
            }`;
    } catch {
        return "";
    }
}

function PriceCard({ item }) {
    const services = Array.isArray(item.services) ? item.services : [];

    return (
        <article className="quay-package">
            <div className="quay-package-top">
                <span className="quay-package-number">
                    {item.number || ""}
                </span>
                <span className="quay-package-label">
                    MINMIN WEDDING - PHÓNG SỰ CƯỚI
                </span>
            </div>

            <h3>{item.title}</h3>

            {item.subtitle && (
                <p className="quay-package-subtitle">{item.subtitle}</p>
            )}

            <div className="quay-divider" />

            <ul className="quay-service-list">
                {services.map((service, index) => (
                    <li key={`${item.id || item.title}-${index}`}>
                        <span className="quay-service-name">
                            {service.name}
                        </span>

                        {service.price !== undefined &&
                            service.price !== null &&
                            service.price !== "" && (
                                <span className="quay-service-price">
                                    {typeof service.price === "number"
                                        ? formatPrice(service.price)
                                        : service.price}
                                </span>
                            )}
                    </li>
                ))}
            </ul>

            {item.completion && (
                <div className="quay-package-complete">
                    <span className="quay-check">✓</span>
                    <span>{item.completion}</span>
                </div>
            )}
        </article>
    );
}

function WeddingVideo({ video }) {
    const embedUrl = getYouTubeEmbedUrl(video.url);

    return (
        <article className="quay-video-card">
            <div className="quay-video-heading">
                <span className="quay-video-number">
                    {video.number || "01"}
                </span>

                <div>
                    <h3>{video.title}</h3>
                    {video.description && <p>{video.description}</p>}
                </div>
            </div>

            <div className="quay-video-frame">
                {embedUrl ? (
                    <iframe
                        src={embedUrl}
                        title={video.title || "Video cưới MinMedia"}
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                ) : (
                    <div className="quay-video-error">
                        {video.url ? (
                            <a
                                href={video.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Mở video trên YouTube
                            </a>
                        ) : (
                            "Video chưa có đường dẫn hợp lệ."
                        )}
                    </div>
                )}
            </div>
        </article>
    );
}

export default function BangGiaQuay() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    async function fetchData(signal) {
        setLoading(true);
        setError("");

        try {
            const response = await fetch(DATA_URL, {
                cache: "no-cache",
                signal,
            });

            if (!response.ok) {
                throw new Error(`Không tải được bảng giá (${response.status}).`);
            }

            const result = await response.json();

            if (!result || !Array.isArray(result.packages)) {
                throw new Error("Dữ liệu JSON chưa có mảng packages hợp lệ.");
            }

            setData(result);
        } catch (err) {
            if (err.name === "AbortError") return;

            console.error("Lỗi tải bảng giá:", err);
            setError(err.message || "Đã xảy ra lỗi khi tải bảng giá.");
        } finally {
            if (!signal?.aborted) setLoading(false);
        }
    }

    useEffect(() => {
        const controller = new AbortController();
        fetchData(controller.signal);

        return () => controller.abort();
    }, []);

    const page = data?.page || {};
    const packages = data?.packages || [];
    const videos = data?.videos || [];
    const closing = data?.closing || {};

    if (loading) {
        return (
            <>
                <main className="quay-page">
                    <section className="quay-status">
                        <div className="quay-loader" />
                        <h1>Đang tải bảng giá</h1>
                        <p>Vui lòng chờ trong giây lát...</p>
                    </section>
                </main>
                <Footer />
            </>
        );
    }

    if (error) {
        return (
            <>
                <main className="quay-page">
                    <section className="quay-status">
                        <span className="quay-eyebrow">MINMIN WEDDING - PHÓNG SỰ CƯỚI</span>
                        <h1>Không tải được bảng giá</h1>
                        <p>{error}</p>
                        <button
                            type="button"
                            className="quay-button"
                            onClick={() => fetchData()}
                        >
                            Thử tải lại ↗
                        </button>
                    </section>
                </main>
                <Footer />
            </>
        );
    }

    return (
        <>
            <main className="quay-page">
                <section className="quay-hero">
                    <div className="quay-container quay-hero-grid">
                        <div className="quay-hero-copy">
                            <span className="quay-eyebrow">
                                {page.eyebrow || "MINMIN · WEDDING FILM"}
                            </span>

                            <h1>{page.title || "BẢNG GIÁ QUAY PHIM CƯỚI"}</h1>

                            {page.description && <p>{page.description}</p>}

                            <a className="quay-button" href="#bang-gia">
                                XEM CÁC GÓI DỊCH VỤ <span>↗</span>
                            </a>

                            <div className="quay-hero-note">
                                <span />
                                GHI LẠI NHỮNG KHOẢNH KHẮC ĐÁNG NHỚ
                            </div>
                        </div>

                        <div className="quay-hero-art">
                            <div className="quay-art-frame">
                                <div className="quay-art-inner">
                                    <img
                                        src={Img}
                                        alt="MinMin Wedding"
                                        className="quay-art-image"
                                    />                                 <span className="quay-art-caption">
                                        MINMIN WEDDING - PHÓNG SỰ CƯỚI
                                    </span>
                                </div>
                            </div>
                            <span className="quay-art-index">01 — WEDDING STORIES</span>
                        </div>
                    </div>
                </section>

                <section className="quay-prices" id="bang-gia">
                    <div className="quay-container">
                        <div className="quay-section-heading">
                            <div>
                                <span className="quay-eyebrow">
                                    PACKAGES & SERVICES
                                </span>
                                <h2>{page.sectionTitle || "Các gói dịch vụ"}</h2>
                                {page.sectionDescription && (
                                    <p>{page.sectionDescription}</p>
                                )}
                            </div>

                            <span className="quay-section-index">
                                01 / BẢNG GIÁ
                            </span>
                        </div>

                        <div className="quay-package-grid">
                            {packages.map((item, index) => (
                                <PriceCard
                                    key={item.id || `${item.title}-${index}`}
                                    item={item}
                                />
                            ))}
                        </div>
                    </div>
                </section>

                {videos.length > 0 && (
                    <section className="quay-films">
                        <div className="quay-container">
                            <div className="quay-section-heading">
                                <div>
                                    <span className="quay-eyebrow">
                                        OUR WEDDING FILMS
                                    </span>
                                    <h2>Video cưới tiêu biểu</h2>
                                    <p>
                                        Những câu chuyện tình yêu được lưu giữ qua từng thước phim.
                                    </p>
                                </div>

                                <span className="quay-section-index">
                                    02 / FILMS
                                </span>
                            </div>

                            <div className="quay-video-grid">
                                {videos.map((video, index) => (
                                    <WeddingVideo
                                        key={video.id || `${video.title}-${index}`}
                                        video={video}
                                    />
                                ))}
                            </div>
                        </div>
                    </section>
                )}

                {/* {(closing.eyebrow || closing.title || closing.description) && (
                    <section className="quay-closing">
                        <div className="quay-container quay-closing-inner">
                            <div>
                                {closing.eyebrow && (
                                    <span className="quay-eyebrow">
                                        {closing.eyebrow}
                                    </span>
                                )}

                                {closing.title && <h2>{closing.title}</h2>}

                                {closing.description && <p>{closing.description}</p>}
                            </div>

                            <a
                                className="quay-button quay-button-light"
                                href="/lien-he"
                            >
                                LIÊN HỆ MINMIN <span>↗</span>
                            </a>
                        </div>
                    </section>
                )} */}
            </main>

            <Footer />
        </>
    );
}
